(function () {
  function init() {
    if (window.matchMedia("(max-width: 989px)").matches) return;

    const gallery = document.querySelector("product-media[id^='product-media-']");
    if (!gallery) return;

    const dotsWrap = gallery.querySelector("[data-pdp-media-dots]");
    if (!dotsWrap) return;

    const items = Array.from(gallery.querySelectorAll("[data-media-item]"));
    const dots = Array.from(dotsWrap.querySelectorAll("[data-pdp-media-dot]"));
    if (!items.length || items.length !== dots.length) return;

    // ✅ container real das imagens no desktop
    const mediaContainer = gallery.closest(".product-desktop-media");
    if (!mediaContainer) return;

    const OFFSET = 18; // igual ao CSS (left/bottom)

    function setActive(index) {
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
    }

    function updateActiveByScroll() {
      const viewportCenter = window.innerHeight / 2;
      let bestIndex = 0;
      let bestDistance = Infinity;

      items.forEach((el, i) => {
        const rect = el.getBoundingClientRect();
        const visible = rect.bottom > 0 && rect.top < window.innerHeight;
        if (!visible) return;

        const elCenter = rect.top + rect.height / 2;
        const dist = Math.abs(elCenter - viewportCenter);

        if (dist < bestDistance) {
          bestDistance = dist;
          bestIndex = i;
        }
      });

      setActive(bestIndex);
    }

    // ✅ Mostrar só enquanto estamos “dentro” do bloco das imagens,
    // e ao chegar ao fundo, prender no fundo do container (absolute)
    function updateVisibilityAndPin() {
      const rect = mediaContainer.getBoundingClientRect();

      // visível se o container das imagens estiver no ecrã
      const isOnScreen = rect.bottom > OFFSET && rect.top < window.innerHeight - OFFSET;
      dotsWrap.classList.toggle("is-visible", isOnScreen);

      if (!isOnScreen) {
        dotsWrap.classList.remove("is-absolute");
        return;
      }

      // se o fundo do container já subiu acima da posição do "fixed bottom",
      // muda para absolute para não “descer” para secções abaixo
      const fixedBottomY = window.innerHeight - OFFSET;
      const shouldPinToContainerBottom = rect.bottom <= fixedBottomY;

      dotsWrap.classList.toggle("is-absolute", shouldPinToContainerBottom);

      if (shouldPinToContainerBottom) {
        // absolute relativo ao mediaContainer
        dotsWrap.style.left = `${OFFSET}px`;
        dotsWrap.style.bottom = `${OFFSET}px`;
      } else {
        // fixed no viewport
        dotsWrap.style.left = `${OFFSET}px`;
        dotsWrap.style.bottom = `${OFFSET}px`;
      }

      updateActiveByScroll();
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const target = items[index];
        if (!target) return;
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        setActive(index);
      });
    });

    updateVisibilityAndPin();
    updateActiveByScroll();

    let ticking = false;
    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updateVisibilityAndPin();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      updateVisibilityAndPin();
      updateActiveByScroll();
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  setTimeout(init, 300);
  setTimeout(init, 1200);
})();
